module.exports = __webpack_public_path__ + "sit/20260420175840/img/service.edbff227.png";